import {
  Directive,
  ElementRef,
  Injector,
  Input,
  OnInit,
  ɵcreateInjector as createInjector,
} from '@angular/core';
import { ZalamoTooltipService } from 'ZalamoLibrary/src/lib/ui/zalamo-tooltip/zalamo-tooltip.service';
import { AliveState } from 'ZalamoLibrary/src/lib/core/ActiveState';
import {
  ReplaySubject,
  combineLatest,
  filter,
  fromEvent,
  map,
  pluck,
  switchMap,
  tap,
} from 'rxjs';

import { TooltipRef } from 'ZalamoLibrary/src/lib/ui/zalamo-tooltip/tooltip-ref';
import { InlineHelpContentComponent } from 'ZalamoLibrary/src/lib/ui/zalamo-inline-help/inline-help-content/inline-help-content.component';
import { Store } from '@ngrx/store';
import { GetInlineHelpGQL } from 'ZalamoLibrary/src/lib/ui/zalamo-inline-help/graphql';
import { RxjsOperators } from 'ZalamoLibrary/src/lib/core/operators/RxjsOperators';
import { IsInlineHelpAdminGQL } from 'ZalamoLibrary/src/lib/ui/zalamo-inline-help-admin/graphql';

@Directive({
  selector: '[libZalamoInlineHelp]',
  standalone: false,
})
export class ZalamoInlineHelpDirective extends AliveState implements OnInit {
  id$ = new ReplaySubject<string>(1);
  helpText = '';
  private _id;
  private isAdmin$ = this.isInlineHelpAdminGQL.fetch({}).pipe(
    pluck('data', 'isInlineHelpAdmin'),
    tap((x) => console.log('INLINE HELP ADMIN', x, this._id)),
  );
  hasHelp$ = combineLatest([
    this.id$.pipe(
      switchMap((id) =>
        this.getInlineHelpGQL
          .fetch({
            variables: {
              id,
            },
          })
          .pipe(pluck('data', 'getZalamoInlineHelp', 'text')),
      ),
      map((text) => {
        this.helpText = text;

        return !!text;
      }),
    ),
    this.isAdmin$,
  ]).pipe(map(([hasText, hasADmin]) => hasText || hasADmin));

  @Input() set libZalamoInlineHelp(id) {
    this.id$.next(id);
    this._id = id;
    console.log('INLINE HELP INITED FOR', id);
  }

  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private zalamoTooltipService: ZalamoTooltipService,
    private store: Store,
    private getInlineHelpGQL: GetInlineHelpGQL,
    private injector: Injector,
    private isInlineHelpAdminGQL: IsInlineHelpAdminGQL,
  ) {
    super();
  }

  ngOnInit() {
    this.subscribeWhileAlive(
      this.hasHelp$.pipe(
        filter((hasHelp) => hasHelp),
        tap(() => {
          console.log('INLINE HELP ');
          const icon = document.createElement('span');
          icon.classList.add('mat-icon', 'material-icons');

          icon.innerHTML = 'info';
          this.elementRef.nativeElement.appendChild(icon);
          const { right } =
            this.elementRef.nativeElement.getBoundingClientRect();
          const config = getComputedStyle(this.elementRef.nativeElement);
          console.log(config.position);
          icon.style.position = 'absolute';
          icon.style.right = `${Math.max(right - screen.width + 20, -30)}px`;
          icon.style.top = '5px';
          icon.style.cursor = 'pointer';
          icon.style.color = '#808080';
          if (config.position === 'static') {
            this.elementRef.nativeElement.style.position = 'relative';
          }
          let ref: TooltipRef<any>;
          this.subscribeWhileAlive(
            fromEvent(icon, 'pointerover').pipe(
              filter(() => !!this.helpText),
              tap(() => {
                console.log('mouse over help');
                ref = this.zalamoTooltipService.open(
                  InlineHelpContentComponent,
                  'above',
                  icon,
                  {
                    isBare: true,
                    hasClose: false,
                    backgroundColor: '#333',
                  },
                );
                ref.componentInstance.message = this.helpText;
              }),
            ),
            fromEvent(icon, 'pointerout').pipe(
              filter(() => !!ref),
              tap(() => {
                // console.log('mouse over help');
                ref.close();
              }),
            ),
            this.isAdmin$.pipe(
              RxjsOperators.filterTruthy(),
              tap(() => {
                if (!this.helpText) {
                  icon.innerHTML = 'info_outline';
                }
                this.subscribeWhileAlive(
                  fromEvent(icon, 'contextmenu').pipe(
                    tap(async () => {
                      console.log('icon clicked');
                      const { ZalamoInlineHelpAdminModule } =
                        await import('ZalamoLibrary/src/lib/ui/zalamo-inline-help-admin/zalamo-inline-help-admin.module');

                      const injector = createInjector(
                        ZalamoInlineHelpAdminModule,
                        this.injector,
                      );
                      const carouselModule = injector.get(
                        ZalamoInlineHelpAdminModule,
                      );
                      carouselModule.showEditor(this.helpText, this._id);
                    }),
                  ),
                );
              }),
            ),
          );
        }),
      ),
    );
  }
}
